import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IProductCatalogItem } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IProductCatalogItem> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
